import BaseModel from "../../common/model/BaseModel";
import BaseCall from "../../common/model/BaseCall";

export default class Home extends BaseModel {

    /**
     * 知识点列表
     */
    static getShareReport(params, fn) {
        BaseCall.get('getShareReport', {params: params}, ({type, data}, res) => {
            let list = data.data
            typeof fn === 'function' ? fn({type, list}) : '';
        });
    }
}
